<template>
  <div class="section-abstract mb-1">
    <v-row class="ma-0 abstract-row" @click="openSection('SectionEtablissementInformationExtend', 'etablissement', false)">
      <v-col>
        <div class="section-abstract-title"></div>
        <v-row class="ma-0">
          <v-col cols="auto" class="pa-0 py-0">
                <v-img v-if="etablissement.logo" :src="etablissement.logo" contain  style="height: 96px; width: 96px; border-radius: 50%; border: 1px solid #ACEBEC;"/>
                <div class="logo-initial" v-else>{{ getInitials(etablissement) }}</div>
            </v-col>
          <v-col class="py-0 align-content-center" style="padding-left: 16px !important; flex: 1 1 0;">
            <div class="section-abstract-title-header pb-2">{{ etablissement.alias }}</div>
            <div class="section-abstract-subtitle-header">{{ etablissement.formeJuridiqueLabel }}</div>
            </v-col>
        </v-row>
      </v-col>
      <v-col cols="1" style=" align-content: center; align-items: center">
        <v-icon class="arrow-icon" style="font-size: 12px; color: #25A3A7;">
          fas fa-chevron-right
        </v-icon>
      </v-col>
    </v-row>
  </div>
</template>
<script lang="ts">
import {defineComponent, type PropType} from "vue";
import SectionEtablissementIdentiteAbstract from "@/generated/sections/SectionEtablissementIdentiteAbstract.vue";
import Etablissement from "@/extend/classes/Etablissement.ts";

export default defineComponent({
  components: {},
  extends: SectionEtablissementIdentiteAbstract,
  methods: {
    getInitials(etab: Etablissement): string {
      const name = etab.alias ? etab.alias : etab.nom;
      const initials = name.split(/[ -]+/);
      if (initials.length > 1) {
        return initials[0][0] + initials[initials.length - 1][0];
      } else {
        return initials[0][0] + initials[0][1];
      }
    }
  }
})
</script>
